module.exports = __webpack_public_path__ + "img/logo_u1992-11.350c08a3.svg";